export enum NotificationType {
    TOAST = 'TOAST',
    BANNER = 'BANNER',
}
